import { Role } from '../../../../enums/Role';
import { GetPermissionFn } from '../types';
import {
  getSchemaForm,
  getInvalidItemDataReference,
  getSchema
} from '../../../../utils';
import {
  isPublishedOrCompletedInCPP,
  isWIPProductionPhase
} from '../../../../utils/status';
import { NodeType } from '../../../../enums/NodeType';

export const updateAudiencesPermission: GetPermissionFn = ({
  hasRole,
  workspace,
  data
}) => {
  if (hasRole(Role.planningReadonly)) {
    return { canView: false, canEdit: false };
  }

  const statusId = data?.props?.status?.[0]?.props?.id;
  const isPublishedOrWIP =
    isPublishedOrCompletedInCPP(statusId) || isWIPProductionPhase(statusId);

  if (isPublishedOrWIP) {
    if (!workspace || !data) {
      return { canView: false, canEdit: false };
    }

    const itemSchema = getSchema(workspace.schemas, NodeType.Item);
    const schemaForm = getSchemaForm(itemSchema, data);
    const invalidDataRef = getInvalidItemDataReference(
      workspace,
      schemaForm,
      data
    );

    if (invalidDataRef) {
      return { canView: false, canEdit: false };
    }
  }

  return { canView: true, canEdit: true };
};
